export type TenantStatus = 'creating' | 'active' | 'suspended' | 'migrated' | 'deleted' | 'incomplete';

export interface Tenant {
  id: string;
  name: string;
  email: string;
  phone?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  country?: string | null;
  logo_url?: string | null;
  portal_url?: string | null;
  status: string;
  tenant_status: TenantStatus;
  subscription_tier?: string | null;
  industry?: string | null;
  company_size?: string | null;
  billing_contact_name?: string | null;
  billing_contact_email?: string | null;
  device_count: number;
  expected_device_count?: number | null;
  onboarded_by?: string | null;
  onboarded_at?: string | null;
  created_at: string;
  updated_at?: string | null;
  updated_by?: string | null;
  partner_id?: string | null;
  domains?: string[] | null;
}

export interface TenantFormData {
  // Business Information
  name: string;
  industry?: string;
  company_size?: string;
  expected_device_count?: number;
  logo_url?: string;
  
  // Contact Information
  email: string;
  phone?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
  
  // Billing Contact
  billing_contact_name?: string;
  billing_contact_email?: string;
  billing_same_as_primary?: boolean;
  
  // Admin Invitation
  invite_admin?: boolean;
  admin_email?: string;
  admin_name?: string;
}

export interface TenantAdminInvitation {
  id: string;
  customer_id: string;
  email: string;
  name?: string | null;
  invited_by?: string | null;
  status: 'pending' | 'accepted' | 'expired' | 'cancelled';
  token: string;
  expires_at: string;
  created_at: string;
  accepted_at?: string | null;
}

export interface TenantDeletionRequest {
  id: string;
  customer_id: string;
  requested_by?: string | null;
  reason?: string | null;
  status: 'pending' | 'approved' | 'rejected';
  reviewed_by?: string | null;
  reviewed_at?: string | null;
  notes?: string | null;
  created_at: string;
}

export const INDUSTRY_OPTIONS = [
  { value: 'technology', label: 'Technology' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'finance', label: 'Finance & Banking' },
  { value: 'education', label: 'Education' },
  { value: 'retail', label: 'Retail' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'government', label: 'Government' },
  { value: 'nonprofit', label: 'Non-Profit' },
  { value: 'other', label: 'Other' },
];

export const COMPANY_SIZE_OPTIONS = [
  { value: '1-50', label: '1-50 employees' },
  { value: '51-200', label: '51-200 employees' },
  { value: '201-500', label: '201-500 employees' },
  { value: '501-1000', label: '501-1000 employees' },
  { value: '1000+', label: '1000+ employees' },
];

export const TENANT_STATUS_CONFIG: Record<TenantStatus, { label: string; color: string; bgColor: string }> = {
  creating: { label: 'Creating', color: 'text-info', bgColor: 'bg-info/10' },
  active: { label: 'Active', color: 'text-success', bgColor: 'bg-success/10' },
  suspended: { label: 'Suspended', color: 'text-warning', bgColor: 'bg-warning/10' },
  migrated: { label: 'Migrated', color: 'text-accent-foreground', bgColor: 'bg-accent' },
  deleted: { label: 'Deleted', color: 'text-destructive', bgColor: 'bg-destructive/10' },
  incomplete: { label: 'Incomplete', color: 'text-muted-foreground', bgColor: 'bg-muted' },
};
